// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetShopArticleByIdRequestModel from '../../model/get-shop-article-by-id-request-model';
import GetShopArticleByIdRequestDTO from '../dto/get-shop-article-by-id-request-dto';
import dtoSchema from '../schemas/get-shop-article-by-id-request-schema';

export default abstract class GetShopArticleByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetShopArticleByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.translatedLanguage_ISO2 = data.translatedLanguage_ISO2;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  translatedLanguage_ISO2?: string;

  static toModel(dto: DeepPartial<GetShopArticleByIdRequestDTO>): GetShopArticleByIdRequestModel;
  static toModel(dto: DeepPartial<GetShopArticleByIdRequestDTO> | undefined | null): GetShopArticleByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetShopArticleByIdRequestDTO> | undefined | null): GetShopArticleByIdRequestModel | undefined {
    return dto ? new GetShopArticleByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetShopArticleByIdRequestModel> | GetShopArticleByIdRequestModel): GetShopArticleByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      translatedLanguage_ISO2: unwrapped.translatedLanguage_ISO2,
    } as GetShopArticleByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetShopArticleByIdRequestModel, can not map to GetShopArticleByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
